module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_paperPearlescent-5f23b48f872711380ae23a50d76baf2c.jpg";